"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resumeType = exports.referencesType = exports.interestsType = exports.languagesType = exports.skillsType = exports.publicationsType = exports.awardsType = exports.educationType = exports.volunteerType = exports.workType = exports.basicsType = exports.profileType = exports.locationType = exports.raz = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
exports.raz = {
    basics: {
        name: "Mehraz Ali",
        label: "Consultant | Builder | Leader | Entrepreneur",
        picture: "./profile-2026.png",
        email: "mehraz.ali@live.com",
        phone: "706.286.4819",
        website: "https://mehrazali.com",
        summary: `Senior Principal Engineer, AI-forward founder, and seasoned technology consultant with 15+ years of experience building and shipping software across consulting and industry. Currently leading large-scale client engagements at Slalom Build while building DogFoodLab — a product studio focused on eliminating friction from everyday life through smart, AI-powered tools. Proven track record of designing complex distributed systems, leading cross-functional teams, and driving AI adoption and acceleration at scale. Passionate about leveraging AI-driven development practices — including Spec-Driven Development (SDD), agentic workflows, and workflow automation — to ship faster and smarter. Equal parts hands-on builder and strategic leader.`,
        location: {
            postalCode: "30319",
            city: "Brookhaven",
            countryCode: "USA",
            region: "Georgia",
        },
        profiles: [
            {
                network: "GitHub",
                username: "FooBarRaz",
                url: "https://www.github.com/FooBarRaz",
            },
            {
                network: "LinkedIn",
                username: "mehraz-ali",
                url: "https://www.linkedin.com/in/mehraz-ali-b42b8412/",
            },
        ],
    },
    work: [
        {
            company: "DogFoodLab",
            position: "Founder & CEO",
            website: "https://dogfoodlab.io",
            startDate: "2025-02-01",
            endDate: "Present",
            summary: `Founder and sole operator of DogFoodLab — a product studio dedicated to cutting through the everyday nonsense. We build smart, innovative tools that let you focus on what truly matters — creating moments of magic in a world full of distractions. The flagship product, StashDog, is currently in active development. DogFoodLab operates at the intersection of AI-driven development, workflow automation, and practical product design.`,
            highlights: [
                "Founded and launched a solo product studio from the ground up",
                "Building StashDog — flagship product in active development",
                "AI-native development workflow using Claude Code, Kiro, and agentic tooling",
                "End-to-end product ownership: ideation, design, architecture, implementation, and GTM",
                "n8n workflow automation for business process pipelines",
                "Supabase",
                "React",
                "TypeScript",
                "Node.js",
                "Serverless Architecture",
            ],
        },
        {
            company: "Slalom Build",
            position: "Senior Principal, Software Engineering",
            website: "https://slalombuild.com",
            startDate: "2019-09-16",
            endDate: "Present",
            summary: `Leading complex, large-scale client engagements from discovery through delivery as a Senior Principal Engineer. Managing and mentoring teams of engineers — providing career guidance, professional development, and technical coaching. Driving AI adoption and acceleration across teams, training and guiding organizations toward effective AI integration at scale. Assessing client business challenges and architecting best-fit technology solutions. Collaborating with delivery managers, stakeholders, and cross-functional teams to scope, estimate, and deliver modern cloud-native applications.`,
            highlights: [
                "Promoted from Principal to Senior Principal (July 2025)",
                "Leading AI adoption and acceleration initiatives across client teams at scale",
                "Training and coaching teams on effective AI-driven development practices",
                "Managing complex, multi-pod client engagements end-to-end",
                "People management and professional development for a growing engineering cohort",
                "Technical strategy, architecture, and solution design",
                "Engagement management and client relationship building",
                "Thought leadership and public speaking",
                "Agile delivery, continuous improvement, and process optimization",
            ],
        },
        {
            company: "Statewide Judicial Technology Organization",
            position: "Principal Engineer / Architect",
            startDate: "2025-04-01",
            endDate: "Present",
            summary: `Principal engineer and architect on the central case-management pod for a statewide judicial digital transformation initiative. Led design, development, and delivery of the core case management product, replacing fragmented legacy court systems with a unified, cloud-native platform for multiple court types and judicial workflows. Served as a principal driver of AI enablement and acceleration, helping the team adopt and evolve AI tooling, engineering practices, and delivery workflows across the project.`,
            highlights: [
                "Led architecture and delivery for the pivotal case-management pod at the center of a multi-pod modernization program",
                "Designed core platform capabilities for end-to-end case lifecycle management across diverse court workflows",
                "Delivered product patterns supporting standardized yet configurable processes for local court variation",
                "Built foundational workflows for cross-court navigation, e-filing, document management, document validation, calendars, and dockets",
                "Partnered with product, design, engineering, and public-sector stakeholders through discovery, MVP delivery, and court onboarding",
                "Helped translate 120+ features and 850+ user stories into executable architecture and delivery plans",
                "Advanced AI-assisted delivery practices across the team, including tooling adoption, workflow design, and engineering enablement",
                "Supported MVP delivery, training, configuration, data migration, and rollout activities for onboarding multiple courts",
                "Cloud-Native Architecture",
                "Case Management Systems",
                "Public Sector",
                "Judicial Workflows",
                "Document Management",
                "Data Migration",
                "AI Enablement",
                "AWS",
            ],
        },
        {
            company: "Aviation Weather Technology Provider",
            position: "Principal Engineer / Architect",
            startDate: "2024-04-01",
            endDate: "2025-03-31",
            summary: `Principal engineer and architect for a one-year modernization of a legacy desktop flight dispatch application into a modern web platform for airline dispatchers. Partnered with an integrated consulting and client engineering/design team through discovery, architecture, product framing, and delivery. Helped define the technical foundation and interaction patterns for a regulated aviation workflow that consolidates weather, flight, route, and alerting data so dispatchers can monitor aircraft from gate departure through arrival.`,
            highlights: [
                "Led architecture and hands-on engineering for a mission-critical aviation dispatch product modernization",
                "Framed the product and technical backlog during a 6-week discovery phase, then delivered through a 52-week build",
                "Designed web application patterns to replace a Windows-dependent thick client with a browser-based dispatch experience",
                "Consolidated disparate weather, route, aircraft, and alerting data into dispatcher-focused workflows",
                "Reduced alert fatigue through clearer prioritization, information architecture, and interaction design",
                "Supported 14 CFR Part 121 flight dispatch monitoring and operational compliance workflows",
                "Helped take the product from pilot feedback in late 2024 to production go-live for two airline customers by March 2025",
                "Contributed foundational architecture and delivery patterns for future aviation products across the client organization",
                "Product Modernization",
                "Aviation Dispatch",
                "Weather Data Visualization",
                "Geospatial Applications",
                "Alerting Workflows",
                "Regulated Systems",
                "React",
                "TypeScript",
            ],
        },
        {
            company: "Regional Bank in Birmingham, Alabama",
            position: "Principal Engineer",
            startDate: "2023-03-01",
            endDate: "2025-01-31",
            summary: `Led the design and delivery of a cloud-native platform for a regional bank, digitizing and consolidating multiple business applications into a unified system. This was the client's first cloud-native initiative, requiring extensive experimentation, stakeholder alignment, organizational change management, and hands-on technical execution. Designed and implemented services, application UIs, and infrastructure in compliance with internal banking policies. Also developed a suite of applications to ensure compliance with upcoming banking regulations.`,
            highlights: [
                "AWS",
                "Lambda",
                "PostgreSQL",
                "Node.js",
                "React",
                "TypeScript",
                "Terraform",
                "DynamoDB",
                "SNS",
                "EventBridge",
                "Step Functions",
                "Prisma",
                "tsoa",
                "RJSF",
                "Regulatory Compliance",
                "Cloud-Native Transformation",
            ],
        },
        {
            company: "Payment Products and Services Provider in Atlanta, GA",
            position: "Principal Engineer",
            startDate: "2022-06-01",
            endDate: "2023-02-28",
            summary: `Designed and built a multi-tenant whitelabel e-commerce platform enabling restaurants to manage and fulfill online orders — essentially a customizable DoorDash-style solution. Implemented real-time order management, menu configuration, and payment processing capabilities across a multi-tenant architecture.`,
            highlights: [
                "Google Cloud Platform",
                "Next.js",
                "React",
                "Firebase",
                "Realtime Database",
                "GraphQL",
                "Multi-tenancy",
                "Accessibility",
                "SEO",
                "Performance Optimization",
            ],
        },
        {
            company: "Automotive Services and Technology Provider in Atlanta, GA",
            position: "Principal Engineer",
            startDate: "2022-06-01",
            endDate: "2023-02-28",
            summary: `Developed and launched an online e-commerce platform to facilitate selling cars digitally. Built out the full buying experience including vehicle search, credit applications, payment processing, and multi-tenant support for dealer networks.`,
            highlights: [
                "Node.js",
                "AWS",
                "React",
                "ElasticSearch",
                "REST APIs",
                "Multi-tenancy",
                "DynamoDB",
                "Step Functions",
                "E-Commerce",
                "Credit Applications",
                "Payment Processing",
            ],
        },
        {
            company: "Leading Cruise Line in Miami, FL",
            position: "Solution Architect",
            startDate: "2022-06-01",
            endDate: "2023-02-28",
            summary: `Architected and developed a system for capturing, storing, managing, and selling photos and media taken on cruise ships — including passenger photos, event coverage, and onboard experiences. The system was designed to run on on-prem hardware aboard the ships with cloud sync capabilities.`,
            highlights: [
                "Photo Management",
                "On-Prem / Hybrid Architecture",
                "Android",
                "Kotlin",
                "AWS",
                "Java",
                "Spring Boot",
                "Angular",
                "MinIO",
            ],
        },
        {
            company: "Animation and Television Studio in Atlanta, GA",
            position: "Solution Architect",
            startDate: "2022-06-01",
            endDate: "2023-02-28",
            summary: `Led the effort to bring a portfolio of mobile games up to spec with new SDKs, platform standards, and California Consumer Privacy Act (CCPA) compliance requirements. Coordinated across a multidisciplinary team spanning legal, development, and QA to evaluate, plan, and execute privacy and technical updates across iOS, Android, and iPad OS titles without disrupting user experience.`,
            highlights: [
                "iOS",
                "Android",
                "iPad OS",
                "Unity",
                "C# .NET",
                "CCPA Compliance",
                "SDK Upgrades",
                "Cross-functional Team Leadership",
                "Mobile Game Portfolio Management",
            ],
        },
        {
            company: "ThoughtWorks",
            position: "Lead Developer, Consultant (prev: Senior Developer)",
            website: "http://thoughtworks.com",
            startDate: "2014-02-01",
            endDate: "2019-09-13",
            summary: `Consultant at a leading global IT services firm, delivering across a wide variety of client projects in financial services, retail, logistics, and more. Responsibilities spanned the full spectrum — from hands-on delivery and architecture to coaching, enablement, and organizational transformation. Built a reputation for technical excellence, clear communication, and elevating team capabilities.`,
            highlights: [
                "Consulting",
                "Agile",
                "Lean and Continuous Delivery",
                "Test-Driven Development",
                "Pair Programming",
                "Education and Mentorship",
                "Public Speaking",
                "Clean Coding Practices",
                "Architecture and Design",
                "Workshops",
                "Process Improvement",
                "Organizational Transformation",
                "Conflict Management",
                "Relationship Building",
            ],
        },
        {
            company: "Kinexys",
            position: "Founder/CXO",
            website: "http://kinexys.com",
            startDate: "2017-01-01",
            endDate: "2024-12-31",
            summary: `Founded Kinexys as a holding company and legal entity for passion projects. Flagship product was Shotcaller — a location-based social media app published to both the Apple App Store and Google Play Store. Took Shotcaller from concept through design, development, and production launch as a solo founder. Company has since been folded; Shotcaller has been sunsetted.`,
            highlights: [
                "Took Shotcaller from inception to production as sole founder",
                "Published to Apple App Store and Google Play Store",
                "Social Media App",
                "iOS",
                "Android",
                "Mobile Web",
                "OAuth 2.0",
                "PostGIS",
                "React Native",
                "Heroku",
                "Ruby on Rails",
                "AWS",
            ],
        },
        {
            company: "Business Development/Analytics Company in Cincinnati, OH",
            position: "Technical Lead/Sr. Software Engineer",
            startDate: "2017-10-01",
            endDate: "2019-04-30",
            summary: `Led a team of 12 developers to build a greenfield analytics platform for a major retailer's vendor ecosystem. The application provided vendors with actionable insights based on retail sales data. Built a full-stack solution with an Angular frontend and a cluster of Spring Boot-powered Java microservices. Coached the team on development and testing best practices while enabling distributed collaboration across multiple locations.`,
            highlights: [
                "Greenfield",
                "Stream Lead",
                "Code-zero to Production",
                "Production Support",
                "Microservices",
                "Pivotal Cloud Foundry",
                "Distributed Team",
                "Feature Toggles",
                "CLI Development",
                "Angular 2/4/6/7",
                "RxJS / NgRx",
                "Java",
                "Spring Boot",
                "Spring Cloud Stream",
                "Spring Batch",
                "RabbitMQ",
            ],
        },
        {
            company: "Consumer Credit Reporting Agency in Atlanta, GA",
            position: "Sr. Software Engineer",
            startDate: "2017-06-01",
            endDate: "2017-10-01",
            summary: `Built a fraud detection and risk analysis system for a consumer credit reporting agency. The system tracked access patterns across factual, situational, and behavioral metrics to build risk profiles and flag fraudulent authentication attempts. Worked on an 8-person team to stand up the backend infrastructure using Java, CassandraDB, Apache Avro, Apache Kafka, and clickstream aggregation tools.`,
            highlights: [
                "Greenfield",
                "Cassandra",
                "Security",
                "Distributed Team",
                "Java",
                "Spring Config Server",
                "Apache Kafka",
                "Apache Avro",
                "Fraud Detection",
            ],
        },
        {
            company: "Credit Card and Payment Services Provider in Wilmington, DE",
            position: "Sr. Software Engineer",
            startDate: "2017-01-01",
            endDate: "2017-06-01",
            summary: `Worked on a large-scale, event-sourced microservices platform serving tens of thousands of daily users for a major payment services provider. Contributed across production support, new product inceptions, and experimental R&D initiatives. Built a developer CLI tool to automate routine development tasks.`,
            highlights: [
                "Microservices",
                "CQRS/Event Sourcing",
                "Production Support",
                "CLI Development",
                "Java",
                "Ruby",
                "Golang",
                "Spring Boot",
                "Spring Cloud Dataflow",
                "Kafka",
                "Axon Framework",
                "Distributed Team",
            ],
        },
        {
            company: "Mortgage Loan and Financial Services Company in Reston, VA",
            position: "Technical Lead/Sr. Developer",
            startDate: "2016-06-01",
            endDate: "2016-12-01",
            summary: `Delivered two engagements for a mortgage and financial services company. First, built a custom testing framework for data engineers to validate ETL jobs — resulting in over 50% reduction in testing time. Then transitioned to coaching 5 scrum teams on Agile development practices through pairing, structured learning, and presentations as they built a next-generation loan delivery system.`,
            highlights: [
                "Greenfield",
                "Coaching and Enablement",
                "AWS",
                "Angular",
                "Full-stack",
                "Spring Boot",
                "Trunk-based Development",
                "Test-Driven Development",
                "Data Testing Framework",
                "ETL",
                "Behaviour Driven Development",
            ],
        },
        {
            company: "Automobile Auction Company in Atlanta, GA",
            position: "Sr. Software Engineer",
            startDate: "2015-03-01",
            endDate: "2016-06-01",
            summary: `Enhanced the capabilities of a legacy messaging platform for an automobile auction company. Built and deployed new services for financial settlements of auctioned vehicles. Coached client developers on best practices for working with legacy systems, including testing, automation, and refactoring techniques.`,
            highlights: [
                "Legacy Modernization",
                "Java",
                "ETL",
                "ActiveMQ",
                "Production Support",
                "Tibco ActiveMatrix/EMS",
                "Informatica",
                "Oracle SQL",
                "AS/400",
            ],
        },
        {
            company: "Cooking Appliances Manufacturer in Columbus, GA",
            position: "Software Developer",
            startDate: "2014-09-01",
            endDate: "2015-02-01",
            summary: "Built a mobile application with a product recommendation engine for a cooking appliances manufacturer.",
            highlights: [
                "Greenfield",
                "Mobile",
                "Recommendation Engine",
                "Full-stack",
                "Ruby on Rails",
            ],
        },
        {
            company: "Human Capital Software Company in Weston, FL",
            position: "Software Developer",
            startDate: "2014-03-01",
            endDate: "2015-08-01",
            summary: "Developed an organizational management and charting application for an HR software company.",
            highlights: [
                "C#",
                ".NET MVC",
                "KnockoutJS",
                "D3.js",
                "Bootstrap",
                "NUnit",
                "Greenfield",
                "Full-stack",
                "Cucumber",
            ],
        },
        {
            company: "CineMassive Displays",
            position: "Software Engineer",
            startDate: "2011-12",
            endDate: "2014-02",
            summary: "Built a desktop application for managing video sources and interfacing with proprietary display hardware.",
            highlights: ["C#", "WPF", "Video Signal Processing", "Full-stack"],
        },
    ],
    volunteer: [
        {
            organization: "ZipCode Wilmington",
            position: "Volunteer",
            website: "https://www.zipcodewilmington.com/",
            startDate: "2017-03",
            highlights: [
                "Helping aspiring software developers work on group projects and prepare for interviews with potential employers",
            ],
        },
        {
            organization: "Digital Youth Founders",
            position: "Volunteer",
            website: "http://organization.com/",
            highlights: [
                "Helping middle and high-school kids learn to build software.",
            ],
        },
        {
            organization: "Trees Atlanta",
            position: "Volunteer",
            website: "http://organization.com/",
            summary: "Planting new trees to replace ones lost to urban development",
            highlights: [],
        },
        {
            organization: "Open Hand",
            position: "Volunteer",
            website: "http://organization.com/",
            summary: "Delivering food and groceries to people with disabilities and chronic illnesses.",
            highlights: ["1,000 pounds of food donations"],
        },
        {
            organization: "Atlanta Community Food Bank",
            position: "Volunteer",
            website: "https://www.acfb.org/",
            summary: "Sorting and packing food donations for distribution to local food pantries.",
        },
        {
            organization: "YMCA",
            position: "Youth Soccer Coach",
            highlights: [],
        },
    ],
    education: [
        {
            institution: "Georgia State University",
            area: "Computer Science",
            studyType: "M.Sc. in Computer Science (incomplete)",
            startDate: "2005-08",
            endDate: "2006-01",
            gpa: "4.30",
            courses: [],
        },
        {
            institution: "University of Georgia",
            area: "Marketing",
            studyType: "Bachelor of Business Administration",
            startDate: "2003-08",
            endDate: "2004-05",
            gpa: "3.2 in Major (Dean's List)",
            courses: [],
        },
    ],
    skills: [
        // --- AI & Modern Tooling ---
        {
            name: "AI-Driven Development",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "Claude Code",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "GitHub Copilot",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Amazon Kiro",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Google Gemini",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "ChatGPT / OpenAI",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Cursor",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Spec-Driven Development (SDD)",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Agentic Workflows",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Workflow Automation (n8n)",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Prompt Engineering",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "AI Team Enablement & Adoption",
            level: 90,
            keywords: ["Technical"],
        },
        // --- Core Stack ---
        {
            name: "TypeScript",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "JavaScript",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "React",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "React Native",
            level: 75,
            keywords: ["Technical"],
        },
        {
            name: "Next.js",
            level: 75,
            keywords: ["Technical"],
        },
        {
            name: "Node.js",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Java",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "Spring Boot",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Python",
            level: 70,
            keywords: ["Technical"],
        },
        {
            name: "Ruby",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Ruby on Rails",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "C#",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Kotlin",
            level: 60,
            keywords: ["Technical"],
        },
        {
            name: "Golang",
            level: 40,
            keywords: ["Technical"],
        },
        // --- Cloud & Infrastructure ---
        {
            name: "AWS",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Lambda",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Terraform",
            level: 75,
            keywords: ["Technical"],
        },
        {
            name: "Docker",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "Google Cloud Platform",
            level: 60,
            keywords: ["Technical"],
        },
        {
            name: "Serverless Architecture",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "CI/CD Pipelines",
            level: 85,
            keywords: ["Technical"],
        },
        {
            name: "Supabase",
            level: 75,
            keywords: ["Technical"],
        },
        {
            name: "Firebase",
            level: 70,
            keywords: ["Technical"],
        },
        // --- Data ---
        {
            name: "PostgreSQL",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "DynamoDB",
            level: 75,
            keywords: ["Technical"],
        },
        {
            name: "MongoDB",
            level: 60,
            keywords: ["Technical"],
        },
        {
            name: "Cassandra",
            level: 65,
            keywords: ["Technical"],
        },
        {
            name: "ElasticSearch",
            level: 65,
            keywords: ["Technical"],
        },
        {
            name: "Kafka",
            level: 70,
            keywords: ["Technical"],
        },
        {
            name: "RabbitMQ",
            level: 70,
            keywords: ["Technical"],
        },
        {
            name: "GraphQL",
            level: 70,
            keywords: ["Technical"],
        },
        {
            name: "Prisma",
            level: 70,
            keywords: ["Technical"],
        },
        // --- Frontend ---
        {
            name: "Angular (2+)",
            level: 80,
            keywords: ["Technical"],
        },
        {
            name: "HTML / CSS",
            level: 90,
            keywords: ["Technical"],
        },
        {
            name: "D3.js",
            level: 50,
            keywords: ["Technical"],
        },
        // --- Mobile ---
        {
            name: "Android",
            level: 70,
            keywords: ["Technical"],
        },
        {
            name: "iOS",
            level: 60,
            keywords: ["Technical"],
        },
        {
            name: "Unity",
            level: 40,
            keywords: ["Technical"],
        },
        // --- Legacy (retained) ---
        {
            name: "AS/400",
            level: 40,
            keywords: ["Technical"],
        },
        {
            name: "Tibco ActiveMatrix/EMS",
            level: 40,
            keywords: ["Technical"],
        },
        {
            name: "KnockoutJS",
            level: 50,
            keywords: ["Technical"],
        },
        {
            name: "PhoneGap",
            level: 40,
            keywords: ["Technical"],
        },
        {
            name: "Grunt",
            level: 50,
            keywords: ["Technical"],
        },
        {
            name: "Gulp",
            level: 50,
            keywords: ["Technical"],
        },
        {
            name: "Cloud Foundry (PCF)",
            level: 75,
            keywords: ["Technical"],
        },
        // --- Testing ---
        {
            name: "Test-Driven Development",
            level: 90,
            keywords: ["Testing"],
        },
        {
            name: "Behaviour Driven Development",
            level: 80,
            keywords: ["Testing"],
        },
        {
            name: "Selenium WebDriver",
            level: 70,
            keywords: ["Testing"],
        },
        {
            name: "Cucumber",
            level: 80,
            keywords: ["Testing"],
        },
        {
            name: "Jest / Mocha / JUnit",
            level: 85,
            keywords: ["Testing"],
        },
        {
            name: "Load & Performance Testing",
            level: 60,
            keywords: ["Testing"],
        },
        {
            name: "Security Testing",
            level: 40,
            keywords: ["Testing"],
        },
        {
            name: "Jenkins",
            level: 80,
            keywords: ["Testing"],
        },
        // --- Consulting ---
        {
            name: "Communication",
            level: 90,
            keywords: ["Consulting"],
        },
        {
            name: "Executive Advisory",
            level: 80,
            keywords: ["Consulting"],
        },
        {
            name: "Facilitation",
            level: 85,
            keywords: ["Consulting"],
        },
        {
            name: "People Management",
            level: 85,
            keywords: ["Consulting"],
        },
        {
            name: "Negotiation",
            level: 80,
            keywords: ["Consulting"],
        },
        {
            name: "Organizational Transformation",
            level: 75,
            keywords: ["Consulting"],
        },
        {
            name: "Presenting / Public Speaking",
            level: 90,
            keywords: ["Consulting"],
        },
        {
            name: "Problem Solving",
            level: 90,
            keywords: ["Consulting"],
        },
        {
            name: "Relationship Building",
            level: 85,
            keywords: ["Consulting"],
        },
        {
            name: "Strategy",
            level: 75,
            keywords: ["Consulting"],
        },
        {
            name: "Teaching / Mentorship",
            level: 90,
            keywords: ["Consulting"],
        },
        {
            name: "AI Adoption Strategy",
            level: 90,
            keywords: ["Consulting"],
        },
        // --- Domain ---
        {
            name: "Financial Services & Insurance",
            level: 80,
            keywords: ["Domain"],
        },
        {
            name: "E-Commerce & Retail",
            level: 80,
            keywords: ["Domain"],
        },
        {
            name: "Automotive",
            level: 65,
            keywords: ["Domain"],
        },
        {
            name: "Entertainment & Media",
            level: 65,
            keywords: ["Domain"],
        },
        {
            name: "SaaS & Product Development",
            level: 80,
            keywords: ["Domain"],
        },
        // --- Languages ---
        {
            name: "Arabic",
            level: 40,
            keywords: ["Language"],
        },
        {
            name: "French",
            level: 40,
            keywords: ["Language"],
        },
        {
            name: "Hindi",
            level: 80,
            keywords: ["Language"],
        },
        {
            name: "Spanish",
            level: 40,
            keywords: ["Language"],
        },
    ],
    languages: [
        {
            name: "English",
            level: "Native speaker",
        },
        {
            name: "Hindi",
            level: "Native speaker",
        },
        {
            name: "Urdu",
            level: "Fluent",
        },
        {
            name: "Arabic",
            level: "Basic",
        },
        {
            name: "Spanish",
            level: "Basic",
        },
        {
            name: "French",
            level: "Basic",
        },
    ],
    interests: [
        {
            name: "Music",
            keywords: [
                "Playing: I play various stringed instruments, from acoustic/electric guitar, to bass, to mandolin",
            ],
        },
        {
            name: "Virtual Reality",
            keywords: ["Vive/Gear VR exploration"],
        },
        {
            name: "Soccer",
            keywords: ["PL: Manchester City", "MLS: Atlanta United"],
        },
        {
            name: "Golf",
            keywords: [],
        },
        {
            name: "Video Games",
            keywords: ["PC/PS4"],
        },
        {
            name: "Outdoors",
            keywords: ["Hiking", "Kayaking", "Biking"],
        },
        {
            name: "Motorsports",
            keywords: ["Racing Aerodynamics", "F1"],
        },
    ],
    references: [],
    awards: [],
    publications: [],
};
exports.locationType = prop_types_1.default.shape({
    address: prop_types_1.default.string,
    postalCode: prop_types_1.default.string,
    city: prop_types_1.default.string,
    countryCode: prop_types_1.default.string,
    region: prop_types_1.default.string,
}).isRequired;
exports.profileType = prop_types_1.default.shape({
    network: prop_types_1.default.string,
    username: prop_types_1.default.string,
    url: prop_types_1.default.string,
}).isRequired;
exports.basicsType = prop_types_1.default.shape({
    name: prop_types_1.default.string,
    label: prop_types_1.default.string,
    picture: prop_types_1.default.string,
    email: prop_types_1.default.string,
    phone: prop_types_1.default.string,
    website: prop_types_1.default.string,
    summary: prop_types_1.default.string,
    location: prop_types_1.default.shape(exports.locationType),
    profiles: prop_types_1.default.arrayOf(exports.profileType),
}).isRequired;
exports.workType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    company: prop_types_1.default.string,
    position: prop_types_1.default.string,
    website: prop_types_1.default.string,
    startDate: prop_types_1.default.string,
    endDate: prop_types_1.default.string,
    summary: prop_types_1.default.string,
    highlights: prop_types_1.default.arrayOf(prop_types_1.default.string),
})).isRequired;
exports.volunteerType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    organization: prop_types_1.default.string,
    position: prop_types_1.default.string,
    website: prop_types_1.default.string,
    startDate: prop_types_1.default.string,
    endDate: prop_types_1.default.string,
    summary: prop_types_1.default.string,
    highlights: prop_types_1.default.arrayOf(prop_types_1.default.string),
})).isRequired;
exports.educationType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    institution: prop_types_1.default.string,
    area: prop_types_1.default.string,
    studyType: prop_types_1.default.string,
    startDate: prop_types_1.default.string,
    endDate: prop_types_1.default.string,
    gpa: prop_types_1.default.string,
    courses: prop_types_1.default.arrayOf(prop_types_1.default.string),
})).isRequired;
exports.awardsType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    title: prop_types_1.default.string,
    date: prop_types_1.default.string,
    awarder: prop_types_1.default.string,
    summary: prop_types_1.default.string,
})).isRequired;
exports.publicationsType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    name: prop_types_1.default.string,
    publisher: prop_types_1.default.string,
    releaseDate: prop_types_1.default.string,
    website: prop_types_1.default.string,
    summary: prop_types_1.default.string,
})).isRequired;
exports.skillsType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    name: prop_types_1.default.string,
    level: prop_types_1.default.number,
    keywords: prop_types_1.default.arrayOf(prop_types_1.default.string),
})).isRequired;
exports.languagesType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    name: prop_types_1.default.string,
    level: prop_types_1.default.string,
})).isRequired;
exports.interestsType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    name: prop_types_1.default.string,
    keywords: prop_types_1.default.arrayOf(prop_types_1.default.string),
})).isRequired;
exports.referencesType = prop_types_1.default.arrayOf(prop_types_1.default.shape({
    name: prop_types_1.default.string,
    reference: prop_types_1.default.string,
})).isRequired;
exports.resumeType = prop_types_1.default.shape({
    basics: exports.basicsType,
    work: exports.workType,
    volunteer: exports.volunteerType,
    education: exports.educationType,
    awards: exports.awardsType,
    publications: exports.publicationsType,
    skills: exports.skillsType,
    languages: exports.languagesType,
    interests: exports.interestsType,
    references: exports.referencesType,
});



// WEBPACK FOOTER //
// ./src/raz-resume.js